export enum Asset {
  FIREARM = 'FIREARM',
  ANCILLARY = 'ANCILLARY',
}
